export const name = "KLL_QUANTILES.EXTRACT_INT64";
export const summary = `Gets a selected number of quantiles from an \`INT64\`-initialized KLL sketch.`;
export const reference = `
## KLL_QUANTILES.EXTRACT_INT64

Gets a selected number of quantiles from an \`INT64\`-initialized KLL sketch.

\`\`\`
KLL_QUANTILES.EXTRACT_INT64(sketch, num_quantiles)
\`\`\`

### Description

Gets a selected number of approximate quantiles from an\`INT64\`-initialized KLL sketch, including the minimum value and the maximum value in the input set.


### Supported Argument Types

- \`sketch\`: \`BYTES\` KLL sketch initialized on the \`INT64\` data type. If this isn't a valid KLL quantiles sketch, or if the underlying data type is different from \`INT64\`, an error is produced.
- \`num_quantiles\`: A positive \`INT64\` value that represents the number of roughly equal-sized subsets that the quantiles partition the sketch-captured input values into. The maximum value is 100,000.


### Details

The number of returned values produced is always \`num_quantiles + 1\` as an array in this order:

- minimum value in input set
- each approximate quantile
- maximum value in input set

For example, if \`num_quantiles\` is \`3\`, and the result of this function is \`[0, 34, 67, 100]\`, this means that \`0\` is the minimum value,\`34\` and \`67\` are the approximate quantiles, and \`100\` is the maximum value. In addition, the result represents the following three segments:\`0 to 34\`, \`34 to 67\`, and \`67 to 100\`.


### Note: This scalar function is similar to the aggregate function
KLL_QUANTILES.MERGE_INT64.




### Return Type

\`ARRAY<INT64>\`


### Example

The following query initializes a KLL sketch, \`kll_sketch\`, from \`Data\`, and then extracts the minimum value (\`0\`), the maximum value (\`100\`), and approximate quantiles in between.



\`\`\`
WITH Data AS (
  SELECT x FROM UNNEST(GENERATE_ARRAY(1, 100)) AS x
)
SELECT
  KLL_QUANTILES.EXTRACT_INT64(kll_sketch, 2) AS halves,
  KLL_QUANTILES.EXTRACT_INT64(kll_sketch, 3) AS terciles,
  KLL_QUANTILES.EXTRACT_INT64(kll_sketch, 4) AS quartiles,
  KLL_QUANTILES.EXTRACT_INT64(kll_sketch, 6) AS sextiles,
FROM (SELECT KLL_QUANTILES.INIT_INT64(x, 1000) AS kll_sketch FROM Data);

/*------------+---------------+------------------+------------------------*
 | halves | terciles | quartiles | sextiles |
 +------------+---------------+------------------+------------------------+
 | [1,50,100] | [1,34,67,100] | [1,25,50,75,100] | [1,17,34,50,67,84,100] |
 *------------+---------------+------------------+------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
